<template>
  <div class="folderDeletionComponent">
    <div class="tree-menu">

      <!-- ERROR MODAL -->
      <b-modal ref="globalAPILoadingErrorModal" id="globalAPILoadingErrorModal"  hide-footer title="Une erreur s'est produite">
        <div class="text-center">
          <p>Une erreur s'est produite, veuillez actualiser la page et réessayer</p>
          <b-button class="mt-3" variant="outline-dark" @click="$bvModal.hide('globalAPILoadingErrorModal')">Fermer</b-button>
        </div>
      </b-modal>

      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#F9BF3B">
      </loading>

      <p>
        Êtes-vous sûr de vouloir supprimer ce dossier ? Vérifiez que ses pages et dossiers enfants
        ont bien été reliés à un autre dossier
      </p>

      <b-button @click="deleteFolder" block pill variant="outline-danger">
         Oui, supprimer
      </b-button>

    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { APIFolder } from '@/api/APIFolder'

const apiFolder = new APIFolder()

export default {
  name: 'folderDeletionComponent',
  props: {
    folder: Object,
    token: String
  },
  components: {
    Loading,
  },
  data() {
     return {
       isDeletingFolder: false,
     }
  },
  computed: {
    isLoading () {
      if (this.isDeletingFolder) {
        return true
      }
      return false
    },
  },
  methods: {
    deleteFolder () {
      this.isDeletingFolder = true
      apiFolder.deleteFolder(
        this.token, this.folder.id)
      .then(() => {
        this.$emit('folder-deleted')
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('folderDeletionComponent deleteFolder API Error : ' + String(error))
      })
      .finally(() => {
        this.isDeletingFolder = false
      })
    },
  }
}
</script>
